export default "__VITE_ASSET__DWQYwKV9__"